import { render, staticRenderFns } from "./Left.vue?vue&type=template&id=70e8c960&scoped=true&"
import script from "./Left.vue?vue&type=script&lang=js&"
export * from "./Left.vue?vue&type=script&lang=js&"
import style0 from "./Left.vue?vue&type=style&index=0&id=70e8c960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e8c960",
  null
  
)

export default component.exports